export default __webpack_public_path__ + "static/media/video_icon_white.79979ad6.svg";